import { Program, ProgramActionType, SET_PROGRAM } from './types';

export const setProgram = (program: Program | null): ProgramActionType => {
	return {
		type: SET_PROGRAM,
		payload: program,
	};
};
